module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "watch.9e64888e.png";